// @ utilities
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const set = require('lodash/object/set');
const merge = require('lodash/object/merge');
const cloneDeep = require('lodash/lang/cloneDeep');
const { createActions } = require('redux-actions');
const apiURLBuilder = require('core/apiURLBuilder');
const { formatText } = require('core/i18n').i18n;

// @ vendors
const moment = require('moment');
//commons
const signaturePatternActions = require('actions/signaturePattern');
// @ constants
const {
    API_ENTERPRISE_NUMBER,
    DATE_FORMAT_API,
    CHARGE_ACCOUNT_PREFIX,
    EURO_TEXT
} = require('constants/index');
const {
    ADVANCE_END_DATE,
    DECREASE_FEE,
    CONTRACT_TYPE,
    YES,
    NO
} = require('../loansConstants/index').amortizationTypes;
const { NOT_ALLOWED_EVIDENCE_PARTIAL_LOAN_REPAYMENT_COUNTRIES } = require("constants/flagBasedFeatures");
const { es: { DATE_FORMAT_WITH_SLASHES } } = require('commonsConstants/dateFormatTypes');
const DateHelper = require('utilities/dateHelper');

const simpleActions = createActions(
    'LOAN_PARTIAL_AMORTIZATION',
    'LOAN_PARTIAL_AMORTIZATION_ERROR',
    'LOAN_PARTIAL_AMORTIZATION_SUCCESS',
 
    'LOAN_PLAN_AMORTIZATION',
    'LOAN_PLAN_AMORTIZATION_ERROR',
    'LOAN_PLAN_AMORTIZATION_SUCCESS',

    'LOAN_PARTIAL_AMORTIZATION_ACCOUNTS_ERROR',
    'LOAN_PARTIAL_AMORTIZATION_LOAN_DATA',
    'LOAN_PARTIAL_AMORTIZATION_UPDATE_ACCOUNT_DETAILS',
    'LOAN_PARTIAL_AMORTIZATION_UPDATE_AMORTIZATION_TYPE',
    'LOAN_PARTIAL_AMORTIZATION_UPDATE_AMOUNT',
    'LOAN_PARTIAL_AMORTIZATION_UPDATE_COMMISSION',
    'LOAN_PARTIAL_AMORTIZATION_UPDATE_MODAL',
    'LOAN_PARTIAL_AMORTIZATION_UPDATE_NEW_DATE',
    'LOAN_PARTIAL_AMORTIZATION_UPDATE_NEW_FEE',
    'LOAN_PARTIAL_AMORTIZATION_UPDATE_PERCENTAGE',
    'LOAN_PARTIAL_AMORTIZATION_WIZARD_SET_VISIBLE_STEP',
    'LOAN_PARTIAL_AMORTIZATION_WIZARD_VALIDATE_STEP',
    'LOAN_PARTIAL_AMORTIZATION_WIZARD_WILL_CANCEL',
    'LOAN_PARTIAL_AMORTIZATION_WIZARD_CLEAR',

    'LOAN_SET_PARTIAL_AMORTIZATION',
    'LOAN_SET_PARTIAL_AMORTIZATION_ERROR',
    'LOAN_SET_PARTIAL_AMORTIZATION_SUCCESS',

    'LOAN_SIMULATE_PARTIAL_AMORTIZATION',
    'LOAN_SIMULATE_PARTIAL_AMORTIZATION_ERROR',
    'LOAN_SIMULATE_PARTIAL_AMORTIZATION_SUCCESS',
    'LOAN_PARTIAL_AMORTIZATION_UPDATE_FINANCIAL_LOSS',
    'LOAN_PARTIAL_AMORTIZATION_ASSOCIATED_ACCOUNT',
    'LOAN_SIMULATE_PARTIAL_STANDARD',
    'LOAN_PARTIAL_AMORTIZATION_INIT_SUCCESS',
    'LOAN_PARTIAL_AMORTIZATION_INIT_ERROR',
    'LOAN_PARTIAL_AMORTIZATION_DOCUMENT_SUCCESS',
    'LOAN_PARTIAL_AMORTIZATION_DOCUMENT_ERROR',
    'LOAN_SIMULATE_PARTIAL_RESET_PDF',
    'LOAN_PARTIAL_AMORTIZATION_READ_DOCUMENT',
    'LOAN_PARTIAL_AMORTIZATION_DOWNLOAD_OR_PRINT_DOCUMENT',
    'LOAN_PARTIAL_AMORTIZATION_FEE_INDICATOR',
    'LOAN_PARTIAL_AMORTIZATION_DUE_INDICATOR',
    'LOAN_PARTIAL_AMORTIZATION_DETAILS_SUCCESS',
    'LOAN_PARTIAL_AMORTIZATION_DETAILS_ERROR',
    'LOAN_PARTIAL_AMORTIZATION_SELECTED_RADIO_BUTTON',
    'SAVED_PARTIAL_AMORTIZATION_SIMULATION_DATA'

);

const updateAmount = data => dispatch => {
    return new Promise(resolve => {
        dispatch(simpleActions.loanPartialAmortizationUpdateAmount({ amount: data }));
        resolve();
    });
};

const requestPartialAmortization = (immLoan, immAccounts) => (dispatch, getState) => {
    const currentState = getState().loanPartialAmortization;
    const isAlreadyFetching = currentState.get('isFetchingPartialAmortization');
    if (!isAlreadyFetching) {
        const requestData = {
            query: {
                producto: immLoan.get('newProduct'),
                numeroContrato: immLoan.get('newContractNumber'),
            }
        };
        dispatch(simpleActions.loanPartialAmortization());

        return APIGet({
            dispatch,
            endpoint: 'loanPartialAmortization',
            params: requestData
        })
            .then(response => {
                const product = immLoan.get('newProduct');
                const contract = immLoan.get('newContractNumber');
                dispatch(simpleActions.loanPartialAmortizationSuccess({ response }));
                dispatch(simpleActions.loanPartialAmortizationLoanData({ response: immLoan }));
                dispatch(simpleActions.loanSimulatePartialStandard({ standard: response.datosGrles.codEstandarRef, productSubType: response.datosGrles.subtipoProducto }));

                let updatedResponse = cloneDeep(response);
                set(updatedResponse, ['consAmorcParcial', 'contrato', 'producto'], product);
                set(updatedResponse, ['consAmorcParcial', 'contrato', 'numerodecontrato'], contract);
                dispatch(simpleActions.loanPartialAmortizationUpdateAccountDetails({ response: { data: updatedResponse, immAccounts } }));
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(simpleActions.loanPartialAmortizationError({ error: response.error }))
                } else {
                    throw response;
                }
            });
    } else {
        return Promise.resolve()
    }
};

const requestPlanAmortization = immLoan => (dispatch, getState) => {
    const currentState = getState().loanRepaymentPlan;
    const isAlreadyFetching = currentState.get('isFetchingPlanAmortization');

    if (!isAlreadyFetching) {
        const codMonedaPrestamo = immLoan.getIn(['balance', 'currency']);
        const fromDate = moment().add(1, 'M').startOf('month');
        const toDate = moment('9999-01-01').startOf('day');

        const requestData = {
            query: {
                codMonedaPrestamo,
                producto: immLoan.get('newProduct'),
                numeroContrato: immLoan.get('newContractNumber'),
                empresa: API_ENTERPRISE_NUMBER,
                operacion: 'A',
                fechaDesde: fromDate.format(DATE_FORMAT_API),
                fechaHasta: toDate.format(DATE_FORMAT_API)
            }
        };

        dispatch(simpleActions.loanPlanAmortization());

        return APIGet({
            dispatch,
            endpoint: 'loanRepaymentPlan',
            params: requestData
        })
            .then(response => dispatch(simpleActions.loanPlanAmortizationSuccess({ response })))
            .catch(response => {
                if (!!response.error) {
                    dispatch(simpleActions.loanPlanAmortizationError({ error: response.error }));
                } else {
                    throw response;
                }
            });
    } else {
        return Promise.resolve()
    }
};

const confirm = data => dispatch => {
    const requiredFixedValues = {
        impOperacion: {
            importe: 0,
            divisa: EURO_TEXT
        },
        impValorResiIni: {
            importe: 0,
            divisa: EURO_TEXT
        },
        impValorResiFin: {
            importe: 0,
            divisa: EURO_TEXT
        }
    }

    const confirmParams = merge(data, requiredFixedValues);
    const params = {
        query: confirmParams
    };

    APIPost({
        dispatch,
        endpoint: 'partialAmortizationSimulatorConfirm',
        params
    })
        .then(response => {
            const { impCuota, fechaVencimiento, fechaValor, impPerdida, impLiquidacion, cuentaAsociada } = response;

            if (response.indCuota === YES) {
                dispatch(simpleActions.loanPartialAmortizationUpdateNewFee({ response: impCuota.importe }));
            } else {
                dispatch(simpleActions.loanPartialAmortizationUpdateNewDate({ response: fechaVencimiento, fechaValor, newExpirationDate: fechaVencimiento }));
                impPerdida && dispatch(simpleActions.loanPartialAmortizationUpdateFinancialLoss({ impPerdida: impPerdida.importe, impLiquidacion: impLiquidacion.importe, contractNumberAccount: cuentaAsociada.detallecontratolocal }));
            }
            dispatch(simpleActions.loanSimulatePartialAmortizationSuccess());
        })
        .catch(() => {
            dispatch(simpleActions.loanSimulatePartialAmortizationError());
        });
};

const confirmationDetails = () => (dispatch, getState) => {
    const loanPartialAmortizationState = getState().loanPartialAmortization;
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const newFF = immFlagBasedFeatures.get(NOT_ALLOWED_EVIDENCE_PARTIAL_LOAN_REPAYMENT_COUNTRIES)
    const amortizationData = loanPartialAmortizationState.getIn(['loanPartialAmortization', 'consAmorcParcial']);
    const amortizationLoanData = loanPartialAmortizationState.getIn(['loanPartialAmortization', 'listaPrestamos', 'prestamo']);
    const amortizationSubProductType = loanPartialAmortizationState.getIn(['loanPartialAmortization', 'datosGrles', 'subtipoProducto']);

    const simulatorData = loanPartialAmortizationState.get('partialAmortizationSimulationData');
    const simulationDataDate = simulatorData.get('amortizationType') === ADVANCE_END_DATE ? YES : NO;
    const simulationDataNFee = simulatorData.get('amortizationType') === DECREASE_FEE ? YES : NO;
    const importeResidualLeasingDivisa = amortizationData.getIn(['importeResidFinal', 'divisa'], EURO_TEXT);

    const contractNumber = loanPartialAmortizationState.getIn(['contract', 'contractNumber']);
    const product = loanPartialAmortizationState.getIn(['contract', 'product']);

    const postData = {
        query: {
            'amortizacionParcial': {
                'campo1JerarquiaParticulariEHIDOBJ1': amortizationData.get('campo1JerarquiaParticulari'),
                'campo2JerarquiaParticularEHIDOBJ2': amortizationData.get('campo2JerarquiaParticular'),
                'codEstandarReferCOESTREF': amortizationData.get('codEstandarRefer'),
                'codOperaBasicaCODOPBAS': amortizationData.get('codOperaBasica'),
                'codProductoContratoIDPROD': amortizationData.get('codProductoContrato'),
                'codTecnicoAplicacionAPLICACI': amortizationData.get('codTecnicoAplicacion'),
                'ctaAsociadaCCC': {
                    'numerodecontrato': amortizationData.getIn(['contrato', 'numerodecontrato']),
                    'producto': amortizationData.getIn(['contrato', 'producto'])
                },
                'cuentaAsociada': {
                    'codbban': amortizationData.getIn(['cuentaAsociada', 'codbban']),
                    'digitodecontrol': amortizationData.getIn(['cuentaAsociada', 'digitodecontrol']),
                    'pais': amortizationData.getIn(['cuentaAsociada', 'pais'])
                },
                'cuentaAsociadaInt': {
                    'codbban': amortizationData.getIn(['cuentaAsociadaInt', 'codbban']),
                    'digitodecontrol': amortizationData.getIn(['cuentaAsociadaInt', 'digitodecontrol']),
                    'pais': amortizationData.getIn(['cuentaAsociadaInt', 'pais'])
                },
                'fechaValorFECVAL1': amortizationData.get('fechaValor'),
                'fechaVencimientoFECVENC2': amortizationData.get('fechaVencimiento'),
                'grupoINDGRU': amortizationData.get('grupo'),
                'importeAmortizarJSP': {
                    'divisa': amortizationData.getIn(['importeAmortiz', 'divisa']),
                    'importe': simulatorData.get('amount')
                },
                'importeLimtActualIMPDIVS2': {
                    'divisa': amortizationData.getIn(['importeLimtActual', 'divisa']),
                    'importe': amortizationData.getIn(['importeLimtActual', 'importe'])
                },
                'importeLimtInicialIMPDIVS1': {
                    'divisa': amortizationData.getIn(['importeLimtInicial', 'divisa']),
                    'importe': amortizationData.getIn(['importeLimtInicial', 'importe'])
                },
                'importeResidFinalIMPDIVS5': {
                    'divisa': amortizationData.getIn(['importeResidFinal', 'divisa']),
                    'importe': amortizationData.getIn(['importeResidFinal', 'importe'])
                },
                'importeResidualLeasingIMPDIVS4': {
                    'divisa': importeResidualLeasingDivisa,
                    'importe': amortizationData.getIn(['importeResidualLeasing', 'importe'])
                },
                'indNOAmortizaPeriodCarenINDNAMCA': amortizationData.get('indNOAmortizaPeriodCaren'),
                'indicaDevolEfectDespAceptINDACTE1': amortizationData.get('indicaDevolEfectDespAcept'),
                'indicaPrestamoLeasingINDPTLEA': amortizationData.get('indicaPrestamoLeasing'),
                'indicadorAmorVencimientoJSP': simulationDataDate,
                'indicadorAmortiCuotaJSP': simulationDataNFee,
                'indicadorDuplicadoINDDUP': amortizationData.get('indicadorDuplicado'),
                'indicadorIntermediacionINDINTER': amortizationData.get('indicadorIntermediacion'),
                'indicadorOrigenDestinoIORIDES': amortizationData.get('indicadorOrigenDestino'),
                'indicadorPrestamoConsuINDPTCON': amortizationData.get('indicadorPrestamoConsu'),
                'indicadorResidenteIDREN': amortizationData.get('indicadorResidente'),
                'nombreMonedaNOMMONCO': amortizationData.get('nombreMoneda'),
                'numeroNUMERO': amortizationData.get('numero'),
                'numeroSecuOperHNUOPEM': amortizationData.get('numeroSecuOper'),
                'origenOrdenMarcajDecretoIDORIGEN': amortizationData.get('origenOrdenMarcajDecreto'),
                'prestamo': {
                    'codbban': amortizationLoanData.getIn(['cuentaAsociada', 'codbban']),
                    'digitodecontrol': amortizationLoanData.getIn(['cuentaAsociada', 'digitodecontrol']),
                    'pais': amortizationLoanData.getIn(['cuentaAsociada', 'pais'])
                },
                'subtipoProductoCODSPROD': amortizationSubProductType,
                'tipoEHTIPOB': amortizationData.get('tipo'),
                'tipoObjetoBTIPOB': amortizationData.get('tipoObjetoBTIPOB'),
                'tipoObjetoOperATIPOB': amortizationData.get('tipoObjetoOper')
            },
            'contrato': {
                'numerodecontrato': contractNumber,
                'producto': product
            },
        }
    };

    return APIPost({
        dispatch,
        endpoint: 'partialAmortizationDetails',
        params: postData
    })
    .then(response => {
        dispatch(simpleActions.loanPartialAmortizationDetailsSuccess(response));
    })
    .catch(response => {
        dispatch(simpleActions.loanPartialAmortizationDetailsError());
    });
}

const details = data => dispatch => {
    const {
        cuentaAsociada,
        cuentaAsociadaVieja,
        fecha,
        fechaVencimiento,
        impAmortiz,
        impLiquidacion,
        prestamo,
        indCuota,
        indVencimiento
    } = data;

    const params = {
        query: {
            cuentaAsociada,
            fecha,
            impAmortiz,
            prestamo
        }
    };

    APIPost({
        dispatch,
        endpoint: 'partialAmortizationSimulatorDetail',
        params
    })
        .then(response => {
            const { datos } = response;

            const confirmData = {
                contratoPrestamo: prestamo,
                cuentaAsociada,
                cuentaAsociadaVieja,
                fechaValor: fecha,
                fechaVencimiento,
                impAmortizacion: impAmortiz,
                impLiquidacion,
                indCuota,
                indVencimiento
            };

            dispatch(simpleActions.loanPartialAmortizationUpdatePercentage({ tasa: datos.dato[0].tasa }));
            dispatch(simpleActions.loanPartialAmortizationAssociatedAccount({ detallecontratolocal: cuentaAsociada.detallecontratolocal }));
            dispatch(confirm(confirmData));
        })
        .catch(() => {
            dispatch(simpleActions.loanSimulatePartialAmortizationError());
        });
};

const validate = data => dispatch => {
    const {
        contratoPrestamo,
        cuentaAsociada,
        cuentaAsociadaVieja,
        saldoPrincipal,
        impAmortizacion,
        indCuota,
        indVencimiento,
        estandarReferencia,
        fecha,
        fechaVencimiento
    } = data;

    const params = {
        query: {
            contratoPrestamo,
            cuentaAsociada,
            cuentaAsociadaVieja,
            saldoPrincipal,
            impAmortizacion: {
                importe: impAmortizacion.importe,
                divisa: impAmortizacion.divisa
            },
            indCuota,
            indVencimiento,
            estandarReferencia
        }
    };

    APIPost({
        dispatch,
        endpoint: 'partialAmortizationSimulatorValidate',
        params
    })
        .then(response => {
            const { impAmortizacion, impLiquidacion } = response;
            const commission = impLiquidacion.importe;
            const validationData = cloneDeep(params.query); //params received here have to be sent to details service
            const validationUpdatedData = {
                fecha,
                fechaVencimiento,
                impAmortiz: {
                    importe: impAmortizacion.importe,
                    divisa: impAmortizacion.divisa
                },
                impLiquidacion: {
                    importe: impLiquidacion.importe,
                    divisa: impLiquidacion.divisa
                },
                prestamo: {
                    detallecontratolocal: contratoPrestamo.detallecontratolocal,
                    tipocontratolocal: contratoPrestamo.tipocontratolocal
                }
            };

            const detailsData = merge(validationData, validationUpdatedData);

            dispatch(simpleActions.loanPartialAmortizationUpdateCommission({ commission }));
            dispatch(details(detailsData));
        })
        .catch(() => {
            dispatch(simpleActions.loanSimulatePartialAmortizationError());
        });
};

const simulatePartialAmortization = (data, immLoan) => (dispatch, getState) => {
    const simulatorData = getState().loanPartialAmortization.get('partialAmortizationSimulationData');
    const amortizationType = data.amortizationType;
    const amount = data.amount;
    const product = immLoan.get('newProduct');
    const contractNumber = immLoan.get('newContractNumber');
    const contractType = CONTRACT_TYPE;
    const contractDetail = CHARGE_ACCOUNT_PREFIX + product + contractNumber
    const isAlreadyFetching = simulatorData.get('isFetching');

    const requestData = {
        query: {
            tipoContratoLocal: contractType,
            detalleContratoLocal: contractDetail
        }
    };

    if (!isAlreadyFetching) {

        dispatch(simpleActions.loanSimulatePartialAmortization());
        return APIGet({
            dispatch,
            endpoint: 'partialAmortizationSimulator',
            params: requestData
        })
            .then(response => {
                const validationData = {
                    contratoPrestamo: response.contratoPrestamo,
                    cuentaAsociada: response.cuentaAsociada,
                    cuentaAsociadaVieja: response.cuentaAsociadaVieja,
                    saldoPrincipal: response.saldoPrincipal,
                    estandarReferencia: response.estandarReferencia,
                    impLiquidacion: response.impLiquidacion,
                    impAmortizacion: {
                        importe: amount,
                        divisa: EURO_TEXT
                    },
                    indCuota: amortizationType === DECREASE_FEE ? YES : NO,
                    indVencimiento: amortizationType === ADVANCE_END_DATE ? YES : NO,
                    fecha: response.fechaValor,
                    fechaVencimiento: response.fechaVencimiento
                };

                dispatch(validate(validationData));
                dispatch(simpleActions.loanSimulatePartialResetPdf());

            })
            .catch(() => {
                dispatch(simpleActions.loanSimulatePartialAmortizationError());
            });
    } else {
        return Promise.resolve();
    }
};

const updateAmountAndSimulateAmortization = (amount, immLoan) => (dispatch, getState) => {

    dispatch(updateAmount(amount))
        .then(() => {
            const simulatorData = getState().loanPartialAmortization.get('partialAmortizationSimulationData');
            const hasAmountError = simulatorData.get('hasAmountError');
            const amortizationType = simulatorData.get('amortizationType') ? simulatorData.get('amortizationType') : ADVANCE_END_DATE;
            const data = {
                amount,
                amortizationType
            };

            if (amount && !hasAmountError) {
                dispatch(simulatePartialAmortization(data, immLoan));
            }
        });
};

const updateAmortizationTypeAndSimulateAmortization = (amortizationType, immLoan) => (dispatch, getState) => {
    const simulatorData = getState().loanPartialAmortization.get('partialAmortizationSimulationData');
    const amount = simulatorData.get('amount');
    const hasAmountError = simulatorData.get('hasAmountError');

    const data = {
        amount: amount,
        amortizationType: amortizationType
    };

    dispatch(simpleActions.loanPartialAmortizationUpdateAmortizationType({ response: data }));

    if (amount && !hasAmountError) {
        dispatch(simulatePartialAmortization(data, immLoan));
    }
};

const postChange = () => (dispatch, getState) => {
    const confirmation = (dataToken) => {
        const loanPartialAmortizationState = getState().loanPartialAmortization;
        const immFlagBasedFeatures = getState().flagBasedFeatures;
        const newFF = immFlagBasedFeatures.get(NOT_ALLOWED_EVIDENCE_PARTIAL_LOAN_REPAYMENT_COUNTRIES)
        const amortizationData = loanPartialAmortizationState.getIn(['loanPartialAmortization', 'consAmorcParcial']);
        const amortizationLoanData = loanPartialAmortizationState.getIn(['loanPartialAmortization', 'listaPrestamos', 'prestamo']);
        const amortizationSubProductType = loanPartialAmortizationState.getIn(['loanPartialAmortization', 'datosGrles', 'subtipoProducto']);

        const simulatorData = loanPartialAmortizationState.get('partialAmortizationSimulationData');
        const simulationDataDate = simulatorData.get('amortizationType') === ADVANCE_END_DATE ? YES : NO;
        const simulationDataNFee = simulatorData.get('amortizationType') === DECREASE_FEE ? YES : NO;
        const importeResidualLeasingDivisa = amortizationData.getIn(['importeResidFinal', 'divisa'], EURO_TEXT);

        const contractNumber = loanPartialAmortizationState.getIn(['contract', 'contractNumber']);
        const product = loanPartialAmortizationState.getIn(['contract', 'product']);
        const scrollDown = loanPartialAmortizationState.get('scrollDown');
        const documentId = loanPartialAmortizationState.get('loanPartialAmortizationDocumentId');
        const acceptanceText = formatText('loanPartialAmortization-pdfDcoumentTitle')
        const operationProcessId = loanPartialAmortizationState.get('operationProcessIdInit');

        const postData = {
            query: {
                'amortizacionParcial': {
                    'campo1JerarquiaParticulariEHIDOBJ1': amortizationData.get('campo1JerarquiaParticulari'),
                    'campo2JerarquiaParticularEHIDOBJ2': amortizationData.get('campo2JerarquiaParticular'),
                    'codEstandarReferCOESTREF': amortizationData.get('codEstandarRefer'),
                    'codOperaBasicaCODOPBAS': amortizationData.get('codOperaBasica'),
                    'codProductoContratoIDPROD': amortizationData.get('codProductoContrato'),
                    'codTecnicoAplicacionAPLICACI': amortizationData.get('codTecnicoAplicacion'),
                    'ctaAsociadaCCC': {
                        'numerodecontrato': amortizationData.getIn(['contrato', 'numerodecontrato']),
                        'producto': amortizationData.getIn(['contrato', 'producto'])
                    },
                    'cuentaAsociada': {
                        'codbban': amortizationData.getIn(['cuentaAsociada', 'codbban']),
                        'digitodecontrol': amortizationData.getIn(['cuentaAsociada', 'digitodecontrol']),
                        'pais': amortizationData.getIn(['cuentaAsociada', 'pais'])
                    },
                    'cuentaAsociadaInt': {
                        'codbban': amortizationData.getIn(['cuentaAsociadaInt', 'codbban']),
                        'digitodecontrol': amortizationData.getIn(['cuentaAsociadaInt', 'digitodecontrol']),
                        'pais': amortizationData.getIn(['cuentaAsociadaInt', 'pais'])
                    },
                    'fechaValorFECVAL1': amortizationData.get('fechaValor'),
                    'fechaVencimientoFECVENC2': amortizationData.get('fechaVencimiento'),
                    'grupoINDGRU': amortizationData.get('grupo'),
                    'importeAmortizarJSP': {
                        'divisa': amortizationData.getIn(['importeAmortiz', 'divisa']),
                        'importe': simulatorData.get('amount')
                    },
                    'importeLimtActualIMPDIVS2': {
                        'divisa': amortizationData.getIn(['importeLimtActual', 'divisa']),
                        'importe': amortizationData.getIn(['importeLimtActual', 'importe'])
                    },
                    'importeLimtInicialIMPDIVS1': {
                        'divisa': amortizationData.getIn(['importeLimtInicial', 'divisa']),
                        'importe': amortizationData.getIn(['importeLimtInicial', 'importe'])
                    },
                    'importeResidFinalIMPDIVS5': {
                        'divisa': amortizationData.getIn(['importeResidFinal', 'divisa']),
                        'importe': amortizationData.getIn(['importeResidFinal', 'importe'])
                    },
                    'importeResidualLeasingIMPDIVS4': {
                        'divisa': importeResidualLeasingDivisa,
                        'importe': amortizationData.getIn(['importeResidualLeasing', 'importe'])
                    },
                    'indNOAmortizaPeriodCarenINDNAMCA': amortizationData.get('indNOAmortizaPeriodCaren'),
                    'indicaDevolEfectDespAceptINDACTE1': amortizationData.get('indicaDevolEfectDespAcept'),
                    'indicaPrestamoLeasingINDPTLEA': amortizationData.get('indicaPrestamoLeasing'),
                    'indicadorAmorVencimientoJSP': simulationDataDate,
                    'indicadorAmortiCuotaJSP': simulationDataNFee,
                    'indicadorDuplicadoINDDUP': amortizationData.get('indicadorDuplicado'),
                    'indicadorIntermediacionINDINTER': amortizationData.get('indicadorIntermediacion'),
                    'indicadorOrigenDestinoIORIDES': amortizationData.get('indicadorOrigenDestino'),
                    'indicadorPrestamoConsuINDPTCON': amortizationData.get('indicadorPrestamoConsu'),
                    'indicadorResidenteIDREN': amortizationData.get('indicadorResidente'),
                    'nombreMonedaNOMMONCO': amortizationData.get('nombreMoneda'),
                    'numeroNUMERO': amortizationData.get('numero'),
                    'numeroSecuOperHNUOPEM': amortizationData.get('numeroSecuOper'),
                    'origenOrdenMarcajDecretoIDORIGEN': amortizationData.get('origenOrdenMarcajDecreto'),
                    'prestamo': {
                        'codbban': amortizationLoanData.getIn(['cuentaAsociada', 'codbban']),
                        'digitodecontrol': amortizationLoanData.getIn(['cuentaAsociada', 'digitodecontrol']),
                        'pais': amortizationLoanData.getIn(['cuentaAsociada', 'pais'])
                    },
                    'subtipoProductoCODSPROD': amortizationSubProductType,
                    'tipoEHTIPOB': amortizationData.get('tipo'),
                    'tipoObjetoBTIPOB': amortizationData.get('tipoObjetoBTIPOB'),
                    'tipoObjetoOperATIPOB': amortizationData.get('tipoObjetoOper')
                },
                'contrato': {
                    'numerodecontrato': contractNumber,
                    'producto': product
                },
                'tokenFirma': dataToken
            }
        };
        if (newFF) {
            const newQuery = {
                ...postData.query,
                operationProcessId: operationProcessId,
                acceptanceText: acceptanceText,
                documentId: documentId,
                scrolldown: scrollDown
            };
            postData.query = newQuery;
            postData.header = {
                'version': '2'
            };
        }
        dispatch(simpleActions.loanSetPartialAmortization());
        return APIPost({
            dispatch,
            endpoint: 'partialAmortizationConfirmation',
            params: postData
        })
            .then((response) => {
                dispatch(simpleActions.loanSetPartialAmortizationSuccess());
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(simpleActions.loanSetPartialAmortizationError());
                } else {
                    throw response;
                }
            });
    };

    const callback = (dispatch, getState, dataToken) => {
        const isInactiveAccount = getState().loanPartialAmortization.get('isInactiveAccount');

        if (isInactiveAccount) {
            dispatch(simpleActions.loanPartialAmortizationAccountsError());
        } else {
            confirmation(dataToken);
        }
    };

    new Promise(() => {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback)
    });
};

const getDocuments = () => (dispatch, getState) => {
    const savedData = getState().loanPartialAmortization.get('savedPartialAmortizationSimulationData');
    const operationProcessIdInit = savedData.get('operationProcessId');
    APIGet(dispatch, `${apiURLBuilder.getURL('loanContractDocuments')}/${operationProcessIdInit}/contract/documents`)
        .then(response => {
            const { base64Document, temporaryDocumentId } = response;
            dispatch(simpleActions.loanPartialAmortizationDocumentSuccess({ base64: base64Document, documentId: temporaryDocumentId }));
        })
        .catch(() => {
            dispatch(simpleActions.loanPartialAmortizationDocumentError());
        });
}

const formatDecimalAmount = (value) => new Intl.NumberFormat('es-ES', { style: 'decimal' }).format(value);

const getInit = data => (dispatch, getState) => {
    const simulatorData = getState().loanPartialAmortization.get('partialAmortizationSimulationData');
    const savedData = getState().loanPartialAmortization.get('savedPartialAmortizationSimulationData');
    const consAmorcParcialData = getState().loanPartialAmortization.getIn(['loanPartialAmortization', 'consAmorcParcial']);
    const loanPartialAmortizationData = getState().loanPartialAmortization;
    const loanAmortizationParameter = getState().loanPartialAmortization.get('loanAmortizationParameter');
    const partialAmortizationDetails = getState().loanPartialAmortization.get('partialAmortizationDetails');
    const loanPartialFinancialLoss = partialAmortizationDetails.perdidaFinanciera.importe;
    const contractNumber = loanPartialAmortizationData.getIn(['contract', 'contractNumber']);
    const newExpirationDate = DateHelper.formatDate(simulatorData.get('newDate'), DATE_FORMAT_WITH_SLASHES)
    const params = {
        query: {
            product: {
                type: loanAmortizationParameter.get('product'),
                subType: loanAmortizationParameter.get('productSubType'),
                standard: simulatorData.get('standard')
            },
            tae: 0,
            tin: 0,
            amount: formatDecimalAmount(simulatorData.get('amount')),
            account: getState().loanPartialAmortization.get('accountNumber'),
            contractNumberAccount: contractNumber,
            processType: 'repayment',
            year: new Date().getFullYear(),
            calculatedOpeningCommission: '0,00',
            financedCommission: '',
            productDuration: 0,
            dueDate: newExpirationDate,
            endOfMonth: false,
            propositionContractNumber: 0,
            propositionNumber: 0,
            firstTime: false,
            loanPurpose: '',
            capitalizedOpeningCommissionIndicator: '',
            loanPartialComissionFee: simulatorData.get('commission'),
            loanPartialFinancialLoss: loanPartialFinancialLoss,
            loanNewAmount: simulatorData.get('newFee'),
            loanNewDate: newExpirationDate,
            loanPartialComissionFinalDate: newExpirationDate,
            loanPartialType: simulatorData.get('amortizationType'),
            loanPartialComissionInterest: simulatorData.get('percentage'),
            productType: 1,
            loanContractNumber: loanAmortizationParameter.get('fullContractNumber'),
            feeIndicator: loanPartialAmortizationData.get('feeIndicator'),
            dueIndicator: loanPartialAmortizationData.get('dueIndicator'),
            operationNumber: consAmorcParcialData.get('numeroSecuOper'),
        }
    };
    if( savedData.get('amount') !== simulatorData.get('amount') || savedData.get('amortizationType') !== simulatorData.get('amortizationType')){
        APIPost({
            dispatch,
            endpoint: 'overdraftInit',
            params
        })
            .then(response => {
                dispatch(simpleActions.loanPartialAmortizationInitSuccess({ operationProcessId: response.operationProcessId }));
                const amount = simulatorData.get('amount');
                const amortizationType = simulatorData.get('amortizationType');
                dispatch(simpleActions.savedPartialAmortizationSimulationData({
                            amount: amount,
                            amortizationType: amortizationType,
                            operationProcessId: response.operationProcessId
                        }));
                dispatch(getDocuments());
            })
            .catch(() => {
                dispatch(simpleActions.loanPartialAmortizationInitError());

            });
    } else {
        dispatch(getDocuments());
    }
};

const validateStep = (step) => (dispatch, getState) => {
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const newFF = immFlagBasedFeatures.get(NOT_ALLOWED_EVIDENCE_PARTIAL_LOAN_REPAYMENT_COUNTRIES)
    const operationProcessIdInit = getState().loanPartialAmortization.get('operationProcessIdInit');
    if (newFF && step === 1) {
        dispatch(simpleActions.loanPartialAmortizationWizardValidateStep(step));
        !operationProcessIdInit && dispatch(getInit());
    }
    else {
        dispatch(simpleActions.loanPartialAmortizationWizardValidateStep(step));
    }
};
const checkReadDocument = (checked) => (dispatch, getState) => {
    dispatch(simpleActions.loanPartialAmortizationReadDocument(checked));
}
const downloadOrPrintDocument = (checked) => (dispatch, getState) => {
    dispatch(simpleActions.loanPartialAmortizationDownloadOrPrintDocument(checked));
}
const setFeeIndicator = (value) => (dispatch, getState) => {
    dispatch(simpleActions.loanPartialAmortizationFeeIndicator(value));
}
const setDueIndicator = (value) => (dispatch, getState) => {
    dispatch(simpleActions.loanPartialAmortizationDueIndicator(value));
}
const setSelectedRadioButton = (value) => (dispatch, getState) => {
    dispatch(simpleActions.loanPartialAmortizationSelectedRadioButton(value));
}
module.exports = {
    confirmationDetails,
    postChange,
    requestPartialAmortization,
    requestPlanAmortization,
    simpleActions,
    updateAmountAndSimulateAmortization,
    updateAmortizationTypeAndSimulateAmortization,
    validateStep,
    checkReadDocument,
    downloadOrPrintDocument,
    setFeeIndicator,
    setDueIndicator,
    setSelectedRadioButton
};
